module.exports = __WEBPACK_EXTERNAL_MODULE__bentley_geometry_core__;